<template>
  <div class="p-grid dashboard">
    <div class="p-col-12">
      <Toast />

      <div class="card">
        <div class="title">Laporan Barang Masuk Per Bulan</div>
        <DataTable
          id="reportTable"
          :lazy="true"
          :value="items"
          :paginator="true"
          class="p-datatable-outlets"
          :rows="limit"
          :total-records="total"
          :rowHover="true"
          :scrollable="true"
          :loading="loading"
          scrollDirection="horizontal"
          @page="onPage"
        >
          <template #header>
            <div class="p-grid p-fluid p-mb-2">
              <div class="p-col-3" style="margin-top: 2.2rem">
                <Calendar
                  v-model="start_date"
                  :showIcon="true"
                  dateFormat="yy-mm-dd"
                  placeholder="Start Date"
                  :selectOtherMonths="true"
                  :showButtonBar="true"
                />
              </div>
              <div class="p-col-3" style="margin-top: 2.2rem">
                <Calendar
                  v-model="end_date"
                  :showIcon="true"
                  dateFormat="yy-mm-dd"
                  placeholder="End Date"
                  :selectOtherMonths="true"
                  :showButtonBar="true"
                />
              </div>
              <div class="p-col-3" style="margin-top: 2.2rem">
                <Button
                  label="Cari"
                  class="p-button-primary"
                  icon="pi pi-search"
                  @click="getReportInboundFilter()"
                  v-shortkey.push="['enter']"
                  @shortkey="getReportInboundFilter()"
                />
              </div>
              <div
                class="p-col-3"
                style="
                  margin-top: 2.2rem;
                  display: flex;
                  justify-content: flex-end;
                "
              >
                <Button
                  label="Export Excel"
                  class="p-button-success"
                  icon="pi pi-file-excel"
                  style="margin-right: 0.5rem"
                  @click="exportToExcel"
                />
                <Button
                  label="Print to PDF"
                  class="p-button-danger"
                  icon="pi pi-file-pdf"
                  @click="printToPDF"
                />
              </div>
            </div>
          </template>
          <template #empty>Data tidak ditemukan.</template>
          <template #loading
            >Mengambil data barang masuk. Mohon tunggu</template
          >
          <Column
            header="Kode Barang"
            field="item_code"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.item_code }}
              </div>
            </template>
          </Column>
          <Column
            header="Nama Barang"
            field="item_name"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.item_name }}
              </div>
            </template>
          </Column>
          <Column
            header="Jumlah Masuk"
            field="qty_in"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">{{ slotProps.data.qty_in }}</div>
            </template>
          </Column>
          <Column
            header="Terjual"
            field="qty_sell"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.qty_sell }}
              </div>
            </template>
          </Column>
          <Column
            header="Retur"
            field="qty_return"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.qty_return }}
              </div>
            </template>
          </Column>
          <Column
            header="Transfer"
            field="qty_transfer"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.qty_transfer }}
              </div>
            </template>
          </Column>
          <Column
            header="Sisa (Qty)"
            field="stock_diifferences"
            headerStyle="text-align: center; width: 10rem"
          >
            <template #body="slotProps">
              <div style="text-align: center">
                {{ slotProps.data.stock_diifferences }}
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require('moment')
import { mapState } from 'vuex'
import * as XLSX from 'xlsx'

export default {
  name: 'ItemsPerMonth',
  computed: {
    ...mapState(['user', 'isAuthenticated'])
  },
  data() {
    return {
      moment: moment,
      loading: true,
      items: [],
      start_date: null,
      end_date: null,
      limit: 10,
      total: 0,
      first: 0,
      page: 1
    }
  },
  watch: {
    user(newValue) {
      console.log('User data changed:', newValue)
    }
  },
  mounted() {
    this.getAuthUser()
    this.getReportInbound()
  },
  methods: {
    getAuthUser() {
      console.info(this.user)
      if (this.user != undefined) {
        console.info('User data:', JSON.stringify(this.user))
      } else {
        console.error('User data is undefined')
      }
      this.start_date = new Date().toISOString().split('T')[0]
      this.end_date = new Date().toISOString().split('T')[0]
    },

    async getReportInbound(page = 1) {
      this.loading = true
      let params = new URLSearchParams({
        page: page,
        limit: this.limit
      })

      if (this.start_date) {
        params.append(
          'start_date',
          moment(this.start_date).format('YYYY-MM-DD')
        )
      }
      if (this.end_date) {
        params.append('end_date', moment(this.end_date).format('YYYY-MM-DD'))
      }

      const url = `${
        process.env.VUE_APP_API_URL
      }/dashboard/outlet-inbounds/report-inbound-items?${params.toString()}`

      try {
        const response = await this.$http.get(url)

        if (response.status === 200) {
          this.items = response.data.data.outlet_inbounds
          this.total = response.data.data.total
          this.first = (page - 1) * this.limit
        } else {
          this.showToast('error', 'Error', 'Gagal mengambil data')
        }
      } catch (error) {
        this.showToast(
          'error',
          'Error',
          'Terjadi kesalahan saat mengambil data'
        )
        console.error('Error fetching report inbound:', error)
      } finally {
        this.loading = false
      }
    },

    getReportInboundFilter() {
      this.loading = true
      if (this.end_date < this.start_date) {
        this.showToast('error', 'Error', 'Gagal mengambil data')
        this.loading = false
        this.start_date = new Date().toISOString().split('T')[0]
        this.end_date = new Date().toISOString().split('T')[0]
      } else {
        this.getReportInbound()
      }
    },

    onPage(event) {
      this.first = event.first
      this.page = event.page + 1
      this.getReportInbound(this.page)
    },

    closeDialog() {
      this.confirmDialog = false
    },

    getRowNumber(index) {
      return index + 1 + this.first
    },

    async fetchAllData() {
      let params = new URLSearchParams()

      if (this.start_date) {
        params.append(
          'start_date',
          moment(this.start_date).format('YYYY-MM-DD')
        )
      }
      if (this.end_date) {
        params.append('end_date', moment(this.end_date).format('YYYY-MM-DD'))
      }

      const url = `${
        process.env.VUE_APP_API_URL
      }/dashboard/outlet-inbounds/report-inbound-items?${params.toString()}&page=1&limit=${
        this.total
      }`

      try {
        const response = await this.$http.get(url)

        if (response.status === 200) {
          return response.data.data.outlet_inbounds
        } else {
          this.showToast('error', 'Error', 'Gagal mengambil data')
          return []
        }
      } catch (error) {
        this.showToast(
          'error',
          'Error',
          'Terjadi kesalahan saat mengambil data'
        )
        console.error('Error fetching all data:', error)
        return []
      }
    },

    async exportToExcel() {
      if (!this.start_date || !this.end_date) {
        this.showToast('error', 'Error', 'Tanggal mulai dan akhir harus diisi')
        return
      }

      const allData = await this.fetchAllData()

      //* this error is happening because the item_id is not defined in the excel file, but that's okay
      const filteredData = allData.map(({ item_id: _, ...rest }) => rest)

      const ws = XLSX.utils.json_to_sheet(filteredData)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1')
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })

      function s2ab(s) {
        const buf = new ArrayBuffer(s.length)
        const view = new Uint8Array(buf)
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff
        return buf
      }

      const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' })
      const filename = 'Laporan Barang Masuk Per Bulan.xlsx'

      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, filename)
      } else {
        // Other browsers
        const link = document.createElement('a')
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob)
          link.setAttribute('href', url)
          link.setAttribute('download', filename)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
    },

    async printToPDF() {
      if (!this.start_date || !this.end_date) {
        this.showToast('error', 'Error', 'Tanggal mulai dan akhir harus diisi')
        return
      }

      this.$root.openLinkNewTab('print-report-items-per-month', {
        start_date: moment(this.start_date).format('YYYY-MM-DD'),
        end_date: moment(this.end_date).format('YYYY-MM-DD')
      })
    }
  }
}
</script>

<style scoped>
::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}
</style>
